import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import DailydeenService from "../../service_v2/dailydeen/dailydeen-service";

const mediaAddOrUpdate = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setUpdateData ] = useState(null);
  const {
    items,
    onOperationComplete,
  } = updateData || {};

  const addUpdateMediaItems = async () => {
    try {
      console.log(`DailyDeen add or update media times...`);
      setResponseData({
        isUpdating: true,
        isError: false,
      });

      console.log("updating items", items)
      const mediaItemsAddUpdateApiResp = await DailydeenService.updateDailyDeenContent(items);
      const responseData = mediaItemsAddUpdateApiResp;

      let errorMsg = null;
      let isError = false;

      console.log("updating complete", responseData)


      if(responseData.errors.length  == 0) {
        console.log('DailyDeen media items add/update Success!!');
      } else {
        console.log('DailyDeen media items add/update Failed!!');
        errorMsg = `Failed to add/update DailyDeen media items.`;
        isError = true;
      }

      setResponseData({
        isUpdating: false,
        isError,
        errorMsg,
        data: responseData.payload,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData.payload,
        });
      }
    } catch (err) {
      console.log('Something went wrong while add/update DailyDeen media items. ', err);
      const errorMsg = `Error occurred while add/update DailyDeen media items.`;
      setResponseData({
        isUpdating: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      addUpdateMediaItems();
    }
  }, [ updateData ]);

  return [
    responseData,
    setUpdateData,
  ];
};

export default mediaAddOrUpdate;